// extracted by mini-css-extract-plugin
export default {"div":"Search_div__eKAI4","input":"Search_input__-3qci","svg":"Search_svg__fAFXw","icon":"Search_icon__SNaID"};